/**
 * Accept either the backend origin or its versioned API base from the
 * server-only CATALOG_API_URL setting.
 */
export function normalizeCatalogApiBase(value) {
  const parsed = new URL(value.trim());
  if (!['http:', 'https:'].includes(parsed.protocol) || parsed.username || parsed.password) {
    throw new Error('CATALOG_API_URL must be an HTTP(S) URL without credentials');
  }

  let pathname = parsed.pathname.replace(/\/+$/, '');
  if (/\/api$/i.test(pathname)) pathname += '/v1';
  else if (!/\/api\/v1$/i.test(pathname)) pathname += '/api/v1';

  return `${parsed.origin}${pathname}`;
}
